var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('con-tab'),_c('home-swiper',{staticClass:"swiper_class",attrs:{"imgList":_vm.imgList}}),_c('need-nei')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }